import { getToken, getToken2, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"
import axios from "axios"

//GET
export const getAllPurchaseOrder = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/get_all_purchase",
      {
        requester: getUser(),
        token: getToken(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const searchPurchaseOrder = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/search",
      {
        requester: getUser(),
        token: getToken(),
        status: data.status,
        order_status: data.order_status,
        supplier_id: data.supplier_id,
        vendor_id: data.vendor_id,
        purchase_date_to: data.purchase_date_to
          ? Moment(data.purchase_date_to).format("YYYY-MM-DD")
          : "",
        purchase_date_from: data.purchase_date_from
          ? Moment(data.purchase_date_from).format("YYYY-MM-DD")
          : "",
        type: data.type,
        limit_by: data.limit_by,
        anything: data.anything,
        page: data.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
export const searchPurchaseOrderPotato = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "purchases/search",
      {
        requester: getUser(),
        token: getToken2(),
        status: data.status,
        order_status: data.order_status,
        supplier_id: data.supplier_id,
        vendor_id: data.vendor_id,
        purchase_date_to: data.purchase_date_to
          ? Moment(data.purchase_date_to).format("YYYY-MM-DD")
          : "",
        purchase_date_from: data.purchase_date_from
          ? Moment(data.purchase_date_from).format("YYYY-MM-DD")
          : "",
        type: data.type,
        limit_by: data.limit_by,
        anything: data.anything,
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// TO PRINT PO AND MERGE ALL ITEMS
export const getPoItems = async (ids) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/get_items",
      {
        requester: getUser(),
        token: getToken(),
        purchase_ids: ids.map((id) => {
          return id.id
        }),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const searchByDate = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/search",
      {
        requester: getUser(),
        token: getToken(),
        purchase_date_from: data.from,
        purchase_date_to: data.to,
        supplier_id: data.supplier_id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getItems = async (data) => {
  //
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/get_all_item",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: data.branchId,
        // all: 1,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAllItems = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/get_all_item",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: id,
        // all: 1,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAllBranches = async () => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "branches/get_all_branch",
      {
        requester: getUser(),
        token: getToken(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getPurchaseOrder = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/get_purchase",
      {
        requester: getUser(),
        token: getToken(),
        purchase_id: id,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const filterPurchaseOrder = async (type) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/filter_purchase_status",
      {
        requester: getUser(),
        token: getToken(),
        status: type,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST
export const createPurchaseOrder = async (PO, items) => {
  var item_count = items?.length
  const formData = new FormData()
  PO.attachments.forEach((file, index) => {
    formData.append(`attachments[]`, file, file.name)
  })
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("is_save", PO.is_save)
  formData.append("branch_id", PO.branch_id)
  if (PO.purchase_request_id) {
    formData.append("purchase_request_id", PO.purchase_request_id)
  }
  formData.append("supplier_id", PO.supplier_id)
  formData.append("forwarder_id", PO.forwarder_id ? PO.forwarder_id : "")
  formData.append(
    "forwarder_contact_person",
    PO.contact_person ? PO.contact_person : ""
  )
  formData.append("status", PO.status)
  formData.append("purchase_date", PO.purchase_date)
  formData.append("delivery_date", PO.delivery_date)
  formData.append("requisitioner", PO.requisitioner.value)
  formData.append("delivery_address", PO.delivery_address)
  formData.append("remarks", PO.remarks || "")
  formData.append("total_purchases", PO.grand_total)
  formData.append("subtotal", PO.subtotal)
  formData.append("grand_total", PO.grand_total)
  formData.append("service_fee", PO.service_fee ? PO.service_fee : 0)
  formData.append("discount", PO.discount ? PO.discount : 0)
  formData.append("contact_no", PO.contact_no ? PO.contact_no : "")
  formData.append("contact_name", PO.contact_name ? PO.contact_name : "")
  formData.append("item_count", item_count)

  items.map((item, index) => {
    formData.append(`item_ids[]`, item.item_id ? item.item_id : "")
    formData.append(`descriptions[]`, item.description ? item.description : "")
    formData.append(`quantities[]`, item.qty)
    formData.append(`units[]`, item.unit)
    formData.append(`prices[]`, item.price)
    formData.append(`item_remarks[]`, item.remarks || "")
    formData.append(`discount_percentages[]`, item.discount_percentage)
    formData.append(`discount_amounts[]`, item.discount_amount)
    formData.append(`item_subamount[]`, item.subtotal)
    formData.append(`item_amount[]`, item.amount)
  })

  try {
    const response = postAPICall(
      process.env.REACT_APP_LINK + "purchases/create",
      formData,
      true
    )
    return response
  } catch (error) {
    return { error: error.response }
  }
}

export const updatePurchaseOrder = async (PO, items) => {
  var item_count = items?.length
  const formData = new FormData()
  PO.attachments.map((file) => {
    formData.append("attachments[]", file, file.name)
    formData.append("attachment_ids[]", null)
  })
  PO.prev_files.map((file) => {
    formData.append("attachment_ids[]", file.id)
  })
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("purchase_id", PO.id)
  formData.append("is_save", PO.is_save)
  formData.append("branch_id", PO.branch_id)
  if (PO.purchase_request_id) {
  }
  formData.append("supplier_id", PO.supplier_id)
  formData.append("forwarder_id", PO.forwarder_id ? PO.forwarder_id : "")
  formData.append(
    "forwarder_contact_person",
    PO.contact_person ? PO.contact_person : ""
  )
  formData.append("status", PO.status)
  formData.append("purchase_date", PO.purchase_date)
  formData.append("delivery_date", PO.delivery_date)
  formData.append("requisitioner", PO.requisitioner.value)
  formData.append("delivery_address", PO.delivery_address)
  formData.append("remarks", PO.remarks || "")
  formData.append("total_purchases", PO.grand_total)
  formData.append("subtotal", PO.subtotal)
  formData.append("grand_total", PO.grand_total)
  formData.append("service_fee", PO.service_fee ? PO.service_fee : 0)
  formData.append("discount", PO.discount ? PO.discount : 0)
  formData.append("contact_no", PO.contact_no ? PO.contact_no : "")
  formData.append("contact_name", PO.contact_name ? PO.contact_name : "")
  formData.append("item_count", item_count)

  items.map((item, index) => {
    formData.append(`item_ids[]`, item.item_id ? item.item_id : "")
    formData.append(`descriptions[]`, item.description ? item.description : "")
    formData.append(`quantities[]`, item.qty)
    formData.append(`units[]`, item.unit)
    formData.append(`prices[]`, item.price)
    formData.append(`item_remarks[]`, item.remarks || "")
    formData.append(`discount_percentages[]`, item.discount_percentage)
    formData.append(`discount_amounts[]`, item.discount_amount)
    formData.append(`item_subamount[]`, item.subtotal)
    formData.append(`item_amount[]`, item.amount)
  })
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "purchases/update",
      formData,
      true
    )
    return response
  } catch (error) {
    return { error: error }
  }
}

export const changeStatusPurchaseOrder = async (id, status) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "purchases/record_action",
      {
        requester: getUser(),
        token: getToken(),
        purchase_id: id,
        action: status,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const changeMultipleStatus = async (ids, status) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "purchases/multiple_record_action",
      {
        requester: getUser(),
        token: getToken(),
        purchase_id: ids.map((item) => {
          return item.id
        }),
        action: status,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deletePurchaseOrder = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "purchases/delete",
      {
        requester: getUser(),
        token: getToken(),
        purchase_id: id,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deletePoAttachment = async (values) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "purchases/delete_attachment",
      {
        requester: getUser(),
        token: getToken(),
        ...values,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const emailPurchaseOrder = async (id) => {
  // const formData = new FormData();
  // // PO.attachments.forEach((file, index) => {
  // //     formData.append(`attachments[]`, file, file.name);
  // // });
  // formData.append('requester', getUser());
  // formData.append('token', getToken());
  // formData.append('id', id);

  // try {
  //     const response = postAPICall(
  //         process.env.REACT_APP_LINK + "emails/send_po",
  //         formData,
  //         true
  //     );
  //     return response
  // } catch (error) {
  //     return { error: error };
  // }

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_po",
      {
        requester: getUser(),
        token: getToken(),
        id: id,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const receivePurchaseOrder = async (PO) => {
  const userDetails = {
    requester: getUser(),
    token: getToken(),
  }
  const payload = {
    ...userDetails,
    ...PO,
  }
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "receives/create",
      {
        ...payload,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const paymentModal = async (purchase_id, payment, balance, payee) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      purchase_id: purchase_id,
      amount: payment.paid_amount ? payment.paid_amount : balance,
      payment_type: payment.payment_type,
      payment_date: payment.payment_date
        ? payment.payment_date
        : payment.deposit_date,
      deposit_date: payment.deposit_date,
      remarks: payment.remarks,
      to_bank_id: payment.to_bank_id,
      to_bank_name: payment.to_bank_name,
      to_account_no: payment.to_account_no,
      to_account_name: payment.to_account_name,
      from_bank_id: payment.from_bank_id,
      from_account_no: payment.from_account_no,
      from_account_name: payment.from_account_name,
      reference_no: payment.reference_number,
      transaction_no: payment.transaction_no,
      transaction_type: payment.transaction_type,
      payment_description: payment.payment_description,
      transaction_fee: payment.transaction_fee,
      payee: payment.payee ? payment.payee : payee,
      particulars: payment.particulars,
      check_no: payment.cheque_number,
      check_date: payment.cheque_date,
      issued_date: payment.issued_date,
    }

    const response = await getAPICall(
      process.env.REACT_APP_LINK + "purchases/add_payment",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const emailPurchaseOrderToSupplier = async (id, file) => {
  const formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("id", id)
  formData.append("attachment", file)

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_po",
      formData,
      true
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const proxyFile = async (fileUrl) => {
  try {
    const apiKey = localStorage.getItem("api_key")
    const headers = {
      "api-key": process.env.REACT_APP_KEY,
      "user-key": apiKey,
    }

    const response = await axios.get(
      process.env.REACT_APP_LINK + "files/proxy_file",
      {
        headers,
        params: {
          requester: getUser(),
          token: getToken(),
          url: fileUrl,
        },
        responseType: "blob",
      }
    )

    return { blob: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
